import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { AccordionProps } from './types';
import clsx from 'clsx';

const Accordion = ({
  title,
  children,
  openByDefault,
  variant = 'default',
  className,
  childrenClassName,
}: AccordionProps) => {
  const [isOpen, setIsOpen] = useState(openByDefault);

  const wrapperClassName =
    variant === 'white'
      ? 'overflow-hidden rounded-lg border border-gray-200 bg-white p-3'
      : 'overflow-hidden border-b border-gray-200';

  return (
    <div className={clsx(wrapperClassName, className)}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex w-full items-center justify-between"
      >
        <span className="text-start text-lg font-semibold">{title}</span>
        <ChevronDown
          className={`h-5 w-5 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}
        />
      </button>
      {isOpen && (
        <div className={clsx('px-1 py-4', childrenClassName)}>{children}</div>
      )}
    </div>
  );
};

export default Accordion;
